module.exports = __webpack_public_path__ + "media/landing-page/hive-right-82f25fd5.png";